export const multipleBeacons = (...beacons) => (action, prevState, nextState) =>
  beacons.map((bcn) => bcn(action, prevState, nextState));
